import React, { Component } from "react";
import { withStyles } from "@material-ui/styles";
import Demo from "../components/Demo";
import Map from "./Map";
import DisplayPanels from "./DisplayPanels";

import styles from "../styles/MapSection";
import SelectionContext from "../contexts/SelectionContext";

class MapSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stateName: "-",
      netTransaction: 0,
      ftoGenerated: 0,
      population: 0,
      allState: [],
    };
  }

  async fetchData() {
    // http://localhost:5000/register/state?year=2022&scheme=Narega&hca2=mp
    // const { selectedState, selectedScheme, selectedYear } = this.props;
    // if (!selectedYear || !selectedScheme || !selectedState) return {};
    const allData = await (
      await fetch(`https://webnior.herokuapp.com/register/state`)
    ).json();
    if (allData.states.length == 0) {
      this.setState({
        stateName: "-",
        netTransaction: 0,
        ftoGenerated: 0,
        population: 0,
      });
    } else {
      this.setState({
        stateName: allData.states[0].State_Name,
        netTransaction: allData.states[0].Total_Transaction,
        ftoGenerated: allData.states[0].FTO_GENRATED,
        population: allData.states[0].POPULATION,
        allState: allData.states,
      });
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedState !== this.props.selectedState ||
      prevProps.selectedScheme !== this.props.selectedScheme ||
      prevProps.selectedYear !== this.props.selectedYear
    )
      this.fetchData();
  }

  render() {
    const { classes, mapData, isDarkMode } = this.props;
    const { stateName, netTransaction, ftoGenerated, population, allState } =
      this.state;

    return (
      <div className={classes.mainContainer}>
        <h4 className={classes.heading}>State/UT: {this.state.stateName}</h4>
        <p className={classes.para}>
          hover over the states in the map to view the stats
        </p>
        <div className={classes.container}>
          <div className={classes.panelsContainer}>
            <div className={classes.singlePanel}>
              <DisplayPanels
                title="State Name"
                number={stateName || "-"}
                isDarkMode={isDarkMode}
                isMiniPanel={true}
              />
            </div>
            <div className={classes.singlePanel}>
              <DisplayPanels
                title="Net Transaction"
                number={netTransaction || "0"}
                isDarkMode={isDarkMode}
                isMiniPanel={true}
              />
            </div>
            <div className={classes.singlePanel}>
              <DisplayPanels
                title="FTO Generated"
                number={ftoGenerated || "0"}
                isDarkMode={isDarkMode}
                isMiniPanel={true}
              />
            </div>
            <div className={classes.singlePanel}>
              <DisplayPanels
                title="Population"
                number={population || "0"}
                isDarkMode={isDarkMode}
                isMiniPanel={true}
              />
            </div>
          </div>
          <div className={classes.mapContainer}>
            {/* <Map mapData={mapData} currentLocation={this.currentLocation} /> */}
            <Demo stateData={allState} />
            
          </div>
        </div>
      </div>
    );
  }
}

MapSection.contextType = SelectionContext;

export default withStyles(styles)(MapSection);
